import api from '@/api'
export default {
  getCenterListBySystem (params) {
    return api({
      url: '/club/clubListSystem',
      method: 'GET',
      params
    })
  },
  getCenterListByOrg (params) {
    return api({
      url: '/club/clubListOrgan',
      method: 'GET',
      params
    })
  },
  addCenter (data) {
    return api({
      url: '/club/clubAdd',
      method: 'POST',
      data
    })
  },
  updateCenter (data) {
    return api({
      url: '/club/clubEdit',
      method: 'PUT',
      data
    })
  },
  getCenterInfo (uuid) {
    return api({
      url: `/youth/clubInfo/${uuid}`,
      method: 'GET'
    })
  },
  getListByOrg (uuid) {
    return api({
      url: `/organ/authorizationOrganListOrgan/${uuid}`,
      method: 'GET'
    })
  },
  getListBySystem (params) {
    return api({
      url: '/organ/authorizationOrganListSystem',
      method: 'GET',
      params
    })
  },
  getYouthSettingData (params) {
    return api({
      url: '/club/clubSettingData',
      method: 'GET',
      params
    })
  },
  setYouthSettingData (data) {
    return api({
      url: '/club/clubSettingSave',
      method: 'POST',
      data
    })
  }
}
